const questions = [
    {
        q: 'One of the following statements is incorrect.' + '<br> <br>' + 'Improving the customer service experience of an organisation to make it more age friendly, requires:',
        a: [
            'Visible commitment from the Executive team.',
            'Leadership support at all levels of the organisation and access to appropriate training.',
            'Embedding this commitment in the organisational culture and all relevant policies.',
            'Employing mostly older people.'
        ],
        correct: 3
    },

    {
        q: 'Is the following statement true or false?' + '<br><br>' + '95% of older South Australians live independently in the community.',
        a: [
            'True',
            'False'
        ],
        correct: 0
    }
];

function buildQuiz(interactiveID, questionIndex) {

    const quizForm = document.getElementById(interactiveID);
    let question = questions[questionIndex];

    let answerStr = buildAnswers(question.a, question, 0);

    let quizStr = `
         <section>
         <div class="flex flex-wrap mb-0">
  <div class=" md:w-1/6  text-center text-gray-200 flex items-center md:justify-center:p-4:w-full sm:p-0 xs:p-0 lg:justify-center:p-4:w-full xl:justify-center:p-4:w-full">
  
    <div class="bg-plus1 flex items-center justify-center bg-sa-blue">
    
    <h2 class="mb-0 text-white question-num">${questionIndex + 1}</h2>
    </div>
  
</div>
  <div class="w-full md:w-5/6 p-4 text-gray-700 flex items-center pl-2 md:pl-4 lg:pl-2 text-sa-blue">
  
    <h2 class="text-sa-blue mb-0">${question.q}</h2> 
  
</div>
</div>

            <form>
                <span style=" display:flex; flex-direction: column" class=" md:ml-40 md:pl-5 sm:mt-0 xs:mt-0 lg:ml-40 xl:ml-40 lg:pl-5 xl:pl-5 ">
                    ${answerStr}
                </span>	
                    
                <button class="btn1 bg-sa-grey-dark hover:bg-sa-blue text-sa-blue hover:text-white font-semibold py-4 px-8 rounded-full float-right w-full text-2xl md:w-1/2 sm:mt-0 xs:mt-0 lg:w-1/2 xl:w-1/4 " id="submit" type="submit">Submit</button>`;
    if (questionIndex + 1 < questions.length) {
        quizStr += `
                <button id="next" class="hidden btn2 bg-sa-grey-dark hover:bg-sa-blue hover:text-white text-sa-blue font-semibold py-4 px-8 rounded-full float-right w-full text-2xl md:w-1/2 sm:mt-0 xs:mt-0 lg:w-1/2 xl:w-1/4 ">Next Question</button>`;
    } else {
        quizStr += `
                <button id="reset" class="hidden btn2 btn2 bg-sa-grey-dark hover:bg-sa-blue hover:text-white text-sa-blue font-semibold py-4 px-8 rounded-full float-right w-full text-2xl md:w-1/2 sm:mt-0 xs:mt-0 lg:w-1/2 xl:w-1/4 ">Reset</button>`;
    }
    quizStr += ` </form>
 </div>
		</section>
		`;



    quizForm.innerHTML = quizStr;

    quizForm.addEventListener('submit', function (e) {
        e.preventDefault();

        // document.getElementsByClassName("bg-plus").style.backgroundColor="green";

        // const alert = e.target.querySelector('div.alert');
        const inputs = e.target.querySelector('input[type=radio]:checked');
        const bg = e.target.querySelectorAll("input[type=radio]");

        const btn1 = e.target.querySelector("button.btn1");
        const btn2 = e.target.querySelector("button.btn2");

        // const str = e.target.querySelectorAll("form.form22");

        if (inputs === null) {

        } else if (inputs.dataset.correct === "true") {
            inputs.parentElement.parentElement.classList.add("mystyle");
            inputs.parentElement.classList.add("mystyle1");

            bg.forEach(function (question) {
                question.disabled = true;
                question.parentElement.classList.remove("mySelectedStyle");
            });

            btn1.classList.add("hidden");
            btn2.classList.remove("hidden");

        } else if (inputs.dataset.correct === "false") {
            inputs.parentElement.parentElement.classList.add("my");
            inputs.parentElement.classList.add("my1");

            bg.forEach(function (question) {
                question.disabled = false;
                question.parentElement.classList.remove("mySelectedStyle");
            });

        } else {

        }
    });

    // quizForm.addEventListener('input', function (e) {
    quizForm.addEventListener('change', function (e) {

        let inputFields = quizForm.querySelectorAll('input');
        let selectedField = quizForm.querySelector('input[type="radio"]:checked');
        // console.log(selectedField);


        // for (let i = 0; i < inputFields.length; ++i) {
        //     console.log(inputFields[i]);
        // }


        //let inputs = event.target.querySelector('input[type=radio]:checked');

        // console.log(checkedBoxes);
        // inputs.parentElement.classList.add("mySelectedStyle");
        // alert(1);

        inputFields.forEach(function (question) {
            question.parentElement.classList.remove("my1", "mystyle1", "mySelectedStyle");
            question.parentElement.parentElement.classList.remove("my", "mystyle", "selected-text" );

        });

        if (selectedField !== null && typeof selectedField !== "undefined") {
            selectedField.parentElement.classList.add("mySelectedStyle");
            selectedField.parentElement.parentElement.classList.add("selected-text");
        }

    }, false);

    if (questionIndex + 1 < questions.length) {
        document.getElementById("next").addEventListener("click", function (e) {
            questionIndex++;
            buildQuiz(interactiveID, questionIndex);
        });
    } else {
        document.getElementById("reset").addEventListener("click", function (e) {
            questionIndex = 0;
            buildQuiz(interactiveID, questionIndex);
        });
    }
};

function init(interactiveID) {

    let currentQuestionIndex = 0;

    buildQuiz(interactiveID, currentQuestionIndex);
}

function buildAnswers(answers, question, qI) {
    let answerStr = '';
    let a = document.getElementById('A1');

    answers.forEach(function (answer, aI) {
        // console.log(aI);
        // const answerOrder = numRange(question.a.length);

        let letter = String.fromCharCode(65 + aI);

        // if(aI === 0){
        //     letter = 'A';
        // } else if(aI === 1){
        //     letter = 'B';
        // }else if(aI === 2){
        //     letter = 'C';
        // }else if(aI === 3){
        //     letter = 'D';
        // }

        answerStr += `
              <div class="w-full cursor-pointer h-auto flex mb-2 back-col">
              
               <div class="p-2">
                <label style="order:" class="flex cursor-pointer">  
                 <span class="bg-plus flex items-center justify-center p-2 align-middle cursor-pointer bg-sa-grey">
                 
                 <div class="letterChange flex items-center justify-center text-1xl font-semibold cursor-pointer">${letter}</div>
                 
                 <span class="correct hidden text-3xl font-semibold cursor-pointer">&#10003;</span>
                 <span class="incorrect hidden text-2xl font-extrabold cursor-pointer">&#10005;</span>
                
                 
                        <input id="in1" type="radio" name="question-${qI}" data-correct="${question.correct === aI}" class="flex items-center justify-center hidden cursor-pointer">
                         </span class="cursor-pointer">
                         <div class="h-auto flex">
                            <div class="flex items-center justify-center align-middle h-auto ml-6 answerText">
                            ${answer}
                            <div> 
                            </div>                   
                        </div>
                    </div>
                </label> 
            </div>
            </div>
         `;
    });

    // let A = document.getElementById('A1');
    // A.innerHTML = 'append';
    //
    // for (let i = 'A'.charCodeAt(0); i <= 'D'.charCodeAt(0); i++) {
    //     A1.append(A);
    // }

    return answerStr;
}

init('quiz001');

// let Current = 0;
// function next(){
//     alert(Current);
//
//     // if(Current == questions.length - 1){
//     //     Current = 0}
//     // else{
//     //     Current++;}
//     //
//     // document.getElementById("quiz001").innerHTML = questions[Current];
// }

// init('quiz002');

// function random(n) {
//
//     const r = Math.random() * n;
//     return Math.floor(r)
// }
//
// function numRange(x){
//     const array = [];
//     for (let i = 0; i < x; i += 1){
//         array.push(i)
//     }
//
//     const numArray = [];
//     while(array.length > 0){
//         const randomI = random(array.length);
//         const randomNum = array[randomI];
//         numArray.push(randomNum);
//         array.splice(randomI, 1)
//
//     }
//
//     return numArray
//
// }

// console.log(numRange(4));

// for (let i = 0; i < 100; i += 1){
// 	random(10)
// }